<template>
  <div>
    <el-row style="margin-bottom: 10px">
      <el-col :span="18" class="flex">
        <el-select
          v-if="theUserProject == 0"
          v-model="theProjectId"
          @change="theProjectAllChange"
          size="small"
          clearable
          placeholder="请选择项目"
        >
          <el-option
            v-for="item in getProjectList_data.data || []"
            :key="item.projectId"
            :label="item.projectName"
            :value="item.projectId"
          >
          </el-option>
        </el-select>
        <el-select v-model="dtLevel" @change="theDtChange" size="small" clearable placeholder="请选择战队">
          <el-option v-for="item in getMyDepartmentLevel_data.data || []" :key="item.dtLevel" :label="item.dtLevelName"
            :value="item.dtLevel">
          </el-option>
        </el-select>
        <el-select
          v-model="time"
          @change="thetimechange"
          size="small"
          clearable
          placeholder="请选择排行时间段"
        >
        <el-option
        v-for="item in timeType"
        :key="item.value"
        :label="item.label"
        :value="item.value">
        </el-option>
          <!-- <el-option label="全部" :value="1"> </el-option>
          <el-option label="今日" :value="2"> </el-option>
          <el-option label="本周" :value="3"> </el-option>
          <el-option label="本月" :value="4"> </el-option> -->
        </el-select>
        <el-select
          v-model="thetype"
          @change="thetypechange"
          size="small"
          clearable
          placeholder="请选择排行类型"
        >
          <el-option label="打卡" :value="1"> </el-option>
          <el-option label="积分" :value="2"> </el-option>
          <el-option label="业绩" :value="3"> </el-option>
          <el-option label="年化业绩" :value="4"> </el-option>
        </el-select>
        <el-date-picker
              size="small"
              v-model="value1"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="selectTime"
              value-format="yyyy-MM-dd"
              >
            </el-date-picker>
        <!-- <el-button
          @click="selectTime"
          type="primary"
          icon="el-icon-search"
          size="small"
          style="margin-left: 10px"
          >搜索
        </el-button> -->
      </el-col>
    </el-row>
    <section v-show="thetype == 2">
      <mytable
        :tableColums="tableColums_getUserMoreIncomeList"
        api="getUserRankJfInUser"
        xupdateapi="updateUserMoreIncome"
        :height="H - 165"
      >
        <div slot="userName" slot-scope="{row}" >
          {{row.userName?row.userName:row.dtName}}
        </div>

      </mytable>
    </section>
    <section v-show="thetype == 1">
      <mytable
        :tableColums="tableColums_getUserMoreIncomeList2"
        api="getUserRankDkInUser::projectId"
        xupdateapi="updateUserMoreIncome"
        :height="H - 165"
      >
      <div slot="userName" slot-scope="{row}" >
        {{row.userName?row.userName:row.dtName}}
      </div>
      </mytable>
    </section>
    <section v-show="thetype == 3">
      <mytable
        :tableColums="tableColums_getUserMoreIncomeList3"
        api="getUserRankYjInUser"
        xupdateapi="updateUserMoreIncome"
        :height="H - 165"
      >
      <div slot="userName" slot-scope="{row}" >
        {{row.userName?row.userName:row.dtName}}
      </div>
      </mytable>
    </section>
    <section v-show="thetype == 4">
      <mytable
        :tableColums="tableColums_getUserMoreIncomeList4"
        api="getUserRankYjYear"
        xupdateapi="updateUserMoreIncome"
        :height="H - 165"
      >
      <div slot="userName" slot-scope="{row}" >
        {{row.userName?row.userName:row.dtName}}
      </div>
      </mytable>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dtLevel:'',
      startDate:"",
      endDate:"",
      value1: '',
      theProjectId: "",
      time: 1,
      thetype: 1,
      timeType:[{
        label:"全部",
        value:1
      },
      {
        label:"今日",
        value:2
      },
      {
        label:"本周",
        value:3
      },
      {
        label:"本月",
        value:4
      },
      ],
      tableColums_getUserMoreIncomeList: {
        $selection: false,
        userName: "用户/团队",
        userPoints: "积分数量",
      },
      tableColums_getUserMoreIncomeList2: {
        $selection: false,
        userName: "用户/团队",

        visitorNum: "打卡次数",
      },
      tableColums_getUserMoreIncomeList3: {
        $selection: false,
        userName: "用户/团队",
        userKpi: "业绩金额(元)",
      },
      tableColums_getUserMoreIncomeList4: {
        $selection: false,
        userName: "用户/团队",
        userKpi: "年化业绩金额(元)",
      },
    };
  },
  methods: {
    selectTime(e){
        this.startDate= e[0]
        this.endDate= e[1]
        this.thetypechange(this.thetype)
        // if (this.thetype == 1) {
        //   this.getUserRankDkInUser({
        //     startDate:this.startDate,
        //     endDate:this.endDate,
        //     getType: this.time,
        //     projectId: this.theProjectId,
        //   });
        // } else if (this.thetype == 2) {
        //   this.getUserRankJfInUser({
        //     startDate:this.startDate,
        //     endDate:this.endDate,
        //     getType: this.time,
        //     projectId: this.theProjectId,
        //   });
        // } else {
        //   this.getUserRankYjInUser({
        //     startDate:this.startDate,
        //     endDate:this.endDate,
        //     getType: this.time,
        //     projectId: this.theProjectId,
        //   });

      // }

    },
    thetypechange(e) {
      this.thetype = e;
      if (e == 1) {
        this.getUserRankDkInUser({
          startDate:this.startDate,
          endDate:this.endDate,
          getType: this.time,
          projectId: this.theProjectId,
          dtLevel:this.dtLevel,
        });
      } else if (e == 2) {
        this.getUserRankJfInUser({
          startDate:this.startDate,
          endDate:this.endDate,
          getType: this.time,
          projectId: this.theProjectId,
          dtLevel:this.dtLevel,
        });
      } else if(e == 3){
        this.getUserRankYjInUser({
          startDate:this.startDate,
          endDate:this.endDate,
          getType: this.time,
          projectId: this.theProjectId,
          dtLevel:this.dtLevel,
        });
      }else{
        this.getUserRankYjYear({
          startDate:this.startDate,
          endDate:this.endDate,
          getType: this.time,
          projectId: this.theProjectId,
          dtLevel:this.dtLevel,
        });
      }

      console.log(this.thetype);
    },
     thetimechange(e) {
      this.time = e;
      this.value1 = '';
      this.startDate = '';
      this.endDate = ''
      console.log(this.startDate)
      if (this.thetype == 1) {
        this.getUserRankDkInUser({
          startDate:this.startDate,
          endDate:this.endDate,
          getType: e,
          projectId: this.theProjectId,
          dtLevel:this.dtLevel,
        });
      } else if (this.thetype == 2) {
        this.getUserRankJfInUser({
          startDate:this.startDate,
          endDate:this.endDate,
          getType: e,
          projectId: this.theProjectId,
          dtLevel:this.dtLevel,
        });
      } else if(this.thetype == 3){
        this.getUserRankYjInUser({
          startDate:this.startDate,
          endDate:this.endDate,
          getType: e,
          projectId: this.theProjectId,
          dtLevel:this.dtLevel,
        });
      }else{
        this.getUserRankYjYear({
          startDate:this.startDate,
          endDate:this.endDate,
          getType: e,
          projectId: this.theProjectId,
          dtLevel:this.dtLevel,
        });
      }

    },
    theDtChange(e){
      this.dtLevel = e;
      if (this.thetype == 1) {
        this.getUserRankDkInUser({
          startDate:this.startDate,
          endDate:this.endDate,
          dtLevel:e,
          projectId: this.theProjectId,
          getType: this.time,

        });
      } else if (this.thetype == 2) {
        this.getUserRankJfInUser({
          startDate:this.startDate,
          endDate:this.endDate,
          dtLevel:e,
          projectId: this.theProjectId,
          getType: this.time,
        });
      } else if(this.thetype == 3) {
        this.getUserRankYjInUser({
          startDate:this.startDate,
          endDate:this.endDate,
          dtLevel:e,
          projectId: this.theProjectId,
          getType: this.time,
        });
      }else {
        this.getUserRankYjYear({
          startDate:this.startDate,
          endDate:this.endDate,
          dtLevel:e,
          projectId: this.theProjectId,
          getType: this.time,
        });
      }
    },
    theProjectAllChange(e) {
      this.theProjectId = e;
      this.value1 = ''
      if (this.thetype == 1) {
        this.getUserRankDkInUser({
          getType: this.time,
          projectId: e,
          dtLevel:this.dtLevel,
        });
      } else if (this.thetype == 2) {
        this.getUserRankJfInUser({
          getType: this.time,
          projectId: e,
          dtLevel:this.dtLevel,
        });
      } else if(this.thetype == 3) {
        this.getUserRankYjInUser({
          getType: this.time,
          projectId: e,
          dtLevel:this.dtLevel,
        });
      }else {
        this.getUserRankYjYear({
          getType: this.time,
          projectId: e,
          dtLevel:this.dtLevel,
        });
      }
      console.log(e);
    },
  },
  created() {
    this.getProjectList({ pageSize: 0 });
    // this.getUserRankDkInUser({
    //   projectId:this.theProjectId
    // })
    this.thetypechange(this.thetype);
    this.theUserProject = A.local("$projectId");
    if (this.theUserProject != 0) {
      this.theProjectId = this.theUserProject;
    }
    this.getMyDepartmentLevel()
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/bussiness/RankManage.vue